import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import { withStyles } from '@material-ui/core/styles';

import Link from 'components/common/Link';
import IconPlus from 'components/icons/IconPlus';
import Menu from 'components/common/Menu';

import RolePermissionsCreateEditModelForm from './RolePermissionsCreateEditModelForm';

const styles = () => ({
  link: {
    textTransform: 'uppercase',
  },
  iconPlus: {
    width: 14,
    height: 14,
    padding: '15px 26px',
    margin: '-15px -13px -15px -26px',
  },
});

class RolePermissionsCreateEditModel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onModelButtonClick = this.onModelButtonClick.bind(this);
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onModelButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget.querySelector('svg'),
    });
  }

  render() {
    const {
      disabled,
      history,
      classes,
    } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <Fragment>
        <Link
          className={classes.link}
          color="primary"
          bold
          size="lg"
          onClick={this.onModelButtonClick}
          disabled={disabled}
          aria-label="More"
          aria-owns="roles-model-menu"
          aria-haspopup="true"
        >
          <IconPlus className={classes.iconPlus} />
          Model On Existing Roles
        </Link>
        <Menu
          id="roles-model-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.onMenuClose}
          list={false}
        >
          <RolePermissionsCreateEditModelForm
            form="modelForm"
            onSubmit={(values) => {
              if (values.Role && values.Role.length > 0) {
                const hrefParams = qs.stringify({ ID: values.Role.map(item => item.value) }, {
                  encode: false, addQueryPrefix: true,
                });
                history.push(`/settings/roles/copy${hrefParams}`);
              }
              this.onMenuClose();
            }}
          />
        </Menu>
      </Fragment>
    );
  }
}

RolePermissionsCreateEditModel.propTypes = {
  disabled: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    link: PropTypes.string.isRequired,
    iconPlus: PropTypes.string.isRequired,
  }).isRequired,
};

RolePermissionsCreateEditModel.defaultProps = {
  disabled: false,
};

export default withRouter(
  withStyles(styles)(RolePermissionsCreateEditModel),
);



// WEBPACK FOOTER //
// ./src/components/settings/RolePermissionsCreateEditForm/RolePermissionsCreateEditModel.js